import "./styles/index.css";
import React from "react";
import ReactDOM from "react-dom/client"; 
import { BrowserRouter as Router } from "react-router-dom";  
import App from "./App";
import { AuthProvider } from "./context/AuthProvider"; 
import { NotificationProvider } from "./context/NotificationContext";
import { ModalProvider } from "./context/ModalContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PermissionsProvider } from "./context/PermissionsContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, 
      staleTime: 5 * 60 * 1000, 
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <QueryClientProvider client={queryClient}>
    <Router>  
      <NotificationProvider>
        <AuthProvider>
          <PermissionsProvider>
            <ModalProvider>
              <App />
            </ModalProvider>
          </PermissionsProvider>
        </AuthProvider>
      </NotificationProvider>
    </Router>
  </QueryClientProvider>

);
